function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m0.44624 20.09c0-10.778 8.7498-19.527 19.527-19.527 10.815 0 19.527 8.7498 19.527 19.527 0 10.815-8.7123 19.527-19.527 19.527-10.778 0-19.527-8.7123-19.527-19.527z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m 0.44624,20.09 c 0,-10.778 8.7498,-19.527 19.527,-19.527 10.815,0 19.527,8.7498 19.527,19.527 0,10.815 -8.7123,19.527 -19.527,19.527 -10.778,0 -19.527,-8.7123 -19.527,-19.527",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 9
});
var SvgSidepanelEmployee2 = function SvgSidepanelEmployee2(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), _ref2, React.createElement("g", {
    style: {
      display: "inline"
    }
  }, _ref3), React.createElement("g", {
    style: {
      display: "inline"
    }
  }, React.createElement("path", {
    d: "m 23.148684,16.144579 0.096,0.132 c 0.965,0.896 2.299,1.45 3.771,1.45 1.473,0 2.806,-0.554 3.771,-1.45 l 0.096,-0.132 0.782,0.147 c 2.263,0.888 3.851,2.968 3.851,5.392 v 4.907 l -2.756,0.929 c -1.863,0.412 -3.789,0.625 -5.744,0.625 -1.955,0 -3.881,-0.213 -5.744,-0.625 l -2.756,-0.929 v -4.907 c 0,-2.424 1.588,-4.504 3.851,-5.392 z",
    stroke: "#002060",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    fill: "#adb9ca",
    fillRule: "evenodd",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeMiterlimit: 8,
      strokeDasharray: "none"
    },
    className: "icon-secondary"
  }), React.createElement("path", {
    d: "m 22.142193,12.662649 c 0,-2.7609994 2.239091,-4.9999986 5,-4.9999986 2.761818,0 5,2.2389992 5,4.9999986 0,2.761 -2.238182,5 -5,5 -2.760909,0 -5,-2.239 -5,-5 z",
    stroke: "#002060",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    fill: "#adb9ca",
    fillRule: "evenodd",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeMiterlimit: 8,
      strokeDasharray: "none"
    },
    className: "icon-secondary"
  }), React.createElement("path", {
    d: "m 9.2209768,16.144579 0.096,0.132 c 0.9650012,0.896 2.2990062,1.45 3.7710062,1.45 1.473,0 2.806,-0.554 3.771,-1.45 l 0.096,-0.132 0.782,0.147 c 2.263,0.888 3.851,2.968 3.851,5.392 v 4.907 l -2.756,0.929 c -1.863,0.412 -3.789,0.625 -5.744,0.625 -1.955002,0 -3.8810062,-0.213 -5.7440062,-0.625 l -2.756,-0.929 v -4.907 c 0,-2.424 1.588,-4.504 3.851,-5.392 z",
    stroke: "#002060",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    fill: "#adb9ca",
    fillRule: "evenodd",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeMiterlimit: 8,
      strokeDasharray: "none"
    },
    className: "icon-secondary"
  }), React.createElement("path", {
    d: "m 8.1180976,12.662649 c 0,-2.7609994 2.2390924,-4.9999986 5.0000074,-4.9999986 2.761818,0 5,2.2389992 5,4.9999986 0,2.761 -2.238182,5 -5,5 -2.760915,0 -5.0000074,-2.239 -5.0000074,-5 z",
    stroke: "#002060",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    fill: "#adb9ca",
    fillRule: "evenodd",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeMiterlimit: 8,
      strokeDasharray: "none"
    },
    className: "icon-secondary"
  }), React.createElement("path", {
    className: "icon-tertiary",
    style: {
      display: "inline",
      fill: "none",
      strokeWidth: 1,
      strokeMiterlimit: 8,
      strokeDasharray: "none"
    },
    fillRule: "evenodd",
    fill: "#adb9ca",
    strokeMiterlimit: 8,
    strokeWidth: 0.666667,
    stroke: "#002060",
    d: "m 22.142193,12.662649 c 0,-2.7609994 2.239091,-4.999999 5,-4.999999 2.761818,0 5,2.2389996 5,4.999999 0,2.761 -2.238182,5 -5,5 -2.760909,0 -5,-2.239 -5,-5 z"
  }), React.createElement("g", {
    transform: "translate(-22.936122,12.86747)",
    className: "icon-tertiary"
  }, React.createElement("path", {
    d: "m 46.084806,3.2771089 0.096,0.132 c 0.965,0.896 2.299,1.45 3.771,1.45 1.473,0 2.806,-0.554 3.771,-1.45 l 0.096,-0.132 0.782,0.147 c 2.263,0.888 3.851,2.968 3.851,5.392 v 4.9070001 l -2.756,0.929 c -1.863,0.412 -3.789,0.625 -5.744,0.625 -1.955,0 -3.881,-0.213 -5.744,-0.625 l -2.756,-0.929 V 8.8161089 c 0,-2.424 1.588,-4.504 3.851,-5.392 z",
    stroke: "#002060",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    fill: "#adb9ca",
    fillRule: "evenodd",
    style: {
      display: "inline",
      fill: "none",
      strokeWidth: 1,
      strokeMiterlimit: 8,
      strokeDasharray: "none"
    },
    className: "icon-tertiary"
  }), React.createElement("path", {
    d: "m 32.157099,3.2771089 0.096,0.132 c 0.965001,0.896 2.299006,1.45 3.771006,1.45 1.473,0 2.806,-0.554 3.771,-1.45 l 0.096,-0.132 0.782,0.147 c 2.263,0.888 3.851,2.968 3.851,5.392 v 4.9070001 l -2.756,0.929 c -1.863,0.412 -3.789,0.625 -5.744,0.625 -1.955002,0 -3.881006,-0.213 -5.744006,-0.625 l -2.756,-0.929 V 8.8161089 c 0,-2.424 1.588,-4.504 3.851,-5.392 z",
    stroke: "#002060",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    fill: "#adb9ca",
    fillRule: "evenodd",
    style: {
      display: "inline",
      fill: "none",
      strokeWidth: 1,
      strokeMiterlimit: 8,
      strokeDasharray: "none"
    },
    className: "icon-tertiary"
  })), React.createElement("path", {
    className: "icon-tertiary",
    style: {
      display: "inline",
      fill: "none",
      strokeWidth: 1,
      strokeMiterlimit: 8,
      strokeDasharray: "none"
    },
    fillRule: "evenodd",
    fill: "#adb9ca",
    strokeMiterlimit: 8,
    strokeWidth: 0.666667,
    stroke: "#002060",
    d: "m 8.1180976,12.662649 c 0,-2.7609994 2.2390914,-4.999999 5.0000074,-4.999999 2.761818,0 5,2.2389996 5,4.999999 0,2.761 -2.238182,5 -5,5 -2.760916,0 -5.0000074,-2.239 -5.0000074,-5 z"
  })), React.createElement("g", {
    style: {
      display: "inline"
    }
  }, React.createElement("path", {
    d: "m 15.87924,18.337351 0.102,0.154 c 1.021,1.045 2.433,1.692 3.992,1.692 1.559,0 2.971,-0.647 3.993,-1.692 l 0.101,-0.154 0.829,0.171 c 2.396,1.037 4.077,3.463 4.077,6.292 v 5.724 l -2.918,1.084 c -1.973,0.48 -4.012,0.729 -6.082,0.729 -2.07,0 -4.109,-0.249 -6.082,-0.729 l -2.918,-1.084 v -5.724 c 0,-2.829 1.681,-5.255 4.078,-6.292 z",
    stroke: "#002060",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    fill: "#ecaec6",
    fillRule: "evenodd",
    style: {
      strokeWidth: 1,
      strokeMiterlimit: 8,
      strokeDasharray: "none",
      stroke: "none"
    },
    className: "icon-primary"
  }), React.createElement("path", {
    d: "m 14.47324,14.644579 c 0,-3.037834 2.463,-5.5000009 5.5,-5.5000009 3.038,0 5.5,2.4621669 5.5,5.5000009 0,3.037834 -2.462,5.500002 -5.5,5.500002 -3.037,0 -5.5,-2.462168 -5.5,-5.500002 z",
    stroke: "#002060",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    fill: "#ecaec6",
    fillRule: "evenodd",
    style: {
      display: "inline",
      stroke: "none",
      strokeWidth: 0.999994,
      strokeMiterlimit: 8,
      strokeDasharray: "none"
    },
    className: "icon-primary"
  }), React.createElement("path", {
    className: "icon-tertiary",
    style: {
      display: "inline",
      fill: "none",
      strokeWidth: 1,
      strokeMiterlimit: 8,
      strokeDasharray: "none"
    },
    fillRule: "evenodd",
    fill: "#ecaec6",
    strokeMiterlimit: 8,
    strokeWidth: 0.666667,
    stroke: "#002060",
    d: "m 15.87924,18.337351 0.102,0.154 c 1.021,1.045 2.433,1.692 3.992,1.692 1.559,0 2.971,-0.647 3.993,-1.692 l 0.101,-0.154 0.829,0.171 c 2.396,1.037 4.077,3.463 4.077,6.292 v 5.724 l -2.918,1.084 c -1.973,0.48 -4.012,0.729 -6.082,0.729 -2.07,0 -4.109,-0.249 -6.082,-0.729 l -2.918,-1.084 v -5.724 c 0,-2.829 1.681,-5.255 4.078,-6.292 z"
  }), React.createElement("path", {
    className: "icon-tertiary",
    style: {
      display: "inline",
      fill: "none",
      strokeWidth: 0.999994,
      strokeMiterlimit: 8,
      strokeDasharray: "none"
    },
    fillRule: "evenodd",
    fill: "#ecaec6",
    strokeMiterlimit: 8,
    strokeWidth: 0.666667,
    stroke: "#002060",
    d: "m 14.47324,14.644579 c 0,-3.037834 2.463,-5.5000009 5.5,-5.5000009 3.038,0 5.5,2.4621669 5.5,5.5000009 0,3.037834 -2.462,5.500002 -5.5,5.500002 -3.037,0 -5.5,-2.462168 -5.5,-5.500002 z"
  })));
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSidepanelEmployee2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sidepanel-employee2.5e57b8cf.svg";
export { ForwardRef as ReactComponent };